import brandTheme from '../../../../Assets/Styles/brandTheme'
import { BUILDER_MAP_COLOR_INACTIVE } from '../../../BuilderMap/const'

const { colors } = brandTheme()

export const updateOverlayStatus = (overlay, isActive) =>
  isActive ? makeOverlayActive(overlay) : makeOverlayInactive(overlay)

const makeOverlayActive = overlay => {
  overlay.set('fillColor', colors.primary)
  overlay.set('strokeColor', colors.primary)
  overlay.set('fillOpacity', 0.7)
  overlay.set('strokeOpacity', 1)
}

const makeOverlayInactive = overlay => {
  overlay.set('fillColor', BUILDER_MAP_COLOR_INACTIVE)
  overlay.set('strokeColor', BUILDER_MAP_COLOR_INACTIVE)
  overlay.set('fillOpacity', 0.2)
  overlay.set('strokeOpacity', 0.4)
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/CreateEditCampaign/CampaignBuilderMap/util.js